import CompanyFileds from './company'
import PatientFileds from './patient'
import ProfessionalFileds from './professional'

export default (Vue) => {
  CompanyFileds(Vue)
  PatientFileds(Vue)
  ProfessionalFileds(Vue)

  Vue.component('f-text', () => import('./text'))
  Vue.component('f-checkbox', () => import('./checkbox'))
  Vue.component('f-email', () => import('./email'))
  Vue.component('f-number', () => import('./number'))
  Vue.component('f-password', () => import('./password'))
  Vue.component('f-select', () => import('./select'))
  Vue.component('f-select2', () => import('./select2'))
  Vue.component('f-select-yes-no', () => import('./select-yes-no'))
  Vue.component('f-select-state', () => import('./select-state'))
  Vue.component('f-select-ajax', () => import('./select-ajax'))
  Vue.component('f-select-city', () => import('./select-city'))
  Vue.component('f-select-company-speciality', () => import('./select-company-speciality'))
  Vue.component('f-select-company-covenant', () => import('./select-company-covenant'))
  Vue.component('f-select-specialization', () => import('./select-specialization'))
  Vue.component('f-select-type-specialization', () => import('./select-type-specialization'))
  Vue.component('f-select-user-location', () => import('./select-user-location'))
  Vue.component('f-select-covenant', () => import('./select-covenant'))
  Vue.component('f-currency', () => import('./masked/currency'))
  Vue.component('f-percent', () => import('./masked/percent'))
  Vue.component('f-date', () => import('./date/date'))
  Vue.component('f-file', () => import('./file'))
  Vue.component('f-file-avatar', () => import('./file-avatar'))
  Vue.component('f-file-content', () => import('./file-content'))
  Vue.component('f-file-text', () => import('./file-text'))
  Vue.component('zip-code', () => import('./zip-code'))
  Vue.component('f-select-professional-speciality', () => import('./select-professional-speciality'))
  Vue.component('f-select-genre', () => import('./select-genre'))
  Vue.component('f-select-entities-register', () => import('./select-entity-register'))
  Vue.component('f-select-loading-specialities', () => import('./loading-page/select-speciality'))
  Vue.component('f-select-loading-cities', () => import('./loading-page/select-cities'))
  Vue.component('personal-information', () => import('./personal_information'))
  Vue.component('company_information', () => import('./company_information'))
  Vue.component('type-clinic', () => import('./typeClinic'))
}



// WEBPACK FOOTER //
// ./src/components/form/fields/index.js